export default (
    window.__URLS__ || {}
)
